'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.Gamification = void 0;
var transport_1 = require("../../transport");
var Gamification = /** @class */ (function () {
    function Gamification() {
    }
    Gamification.prototype.leaderboard = function (params) {
        return transport_1.transport.request('gamification/leaderboard', params);
    };
    Gamification.prototype.achievement = function (params) {
        return transport_1.transport.request('gamification/achievement', params);
    };
    Gamification.prototype.collectGameClickEvents = function (params) {
        return transport_1.transport.request('gamificationV2/pushGameClickEvents', params);
    };
    return Gamification;
}());
exports.Gamification = Gamification;
